import React  from 'react';
import styled from 'styled-components';
import ContactForm from '@/components/landing/contact/ContactForm';
import { breakpoints } from '@/layouts/breakpoints';
import { Mail, Phone, MessageCircleQuestionMark} from 'lucide-react';

const ContactSection: React.FC = () => {
  return (
    <StyledContactSection>
      <ContactForm />

      <div className="contact-info">
        <div className="info-item">
          <div className="icon">
            <Mail size={20} color="var(--grey)" />
          </div>
          <div className="details">
            <h3 className="sans">EMAIL US</h3>
            <a href="mailto:contact@axionquant.com">contact@axionquant.com</a>
          </div>
        </div>

        <div className="info-item">
          <div className="icon">
            <MessageCircleQuestionMark size={20} color="var(--grey)" />
          </div>
          <div className="details">
            <h3 className="sans">NEED PRODUCT SUPPORT?</h3>
            <a href="mailto:support@axionquant.com">support@axionquant.com</a>
          </div>
        </div>


        <div className="info-item">
          <div className="icon">
            <Phone size={20} color="var(--grey)" />
          </div>
          <div className="details">
            <h3 className="sans">CALL US</h3>
            <a href="tel:+1-505-465-7851">+1 (505) 465-7851</a>
          </div>
        </div>

      </div>


    </StyledContactSection>
  );
};

const StyledContactSection = styled.div`
  padding: 80px 40px;
  display: flex;
  flex-direction: row-reverse;
  gap: 80px;
  max-width: 1400px;
  margin: 0 auto;

  .contact-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 40px;
    padding-top: 20px;

    .info-item {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      gap: 24px;

      .icon {
        flex-shrink: 0;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background: rgba(var(--greyr), 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .details {
        h3 {
          font-size: 18px;
          letter-spacing: 0.5px;
          margin-bottom: 8px;
        }
        p, a {
          font-size: 15px;
          line-height: 1.7;
          color: var(--grey);
          text-decoration: none;
          transition: color 0.2s;

          &:hover {
            color: var(--black);
          }
        }
      }
    }
  }

  @media (max-width: 1024px) {
      flex-direction: column-reverse;
      gap: 60px;
      padding: 40px 20px;
  }

  @media (max-width: ${breakpoints.xsmall}) {
      padding: 32px 16px;
      gap: 40px;

      .contact-info {
        gap: 32px;

        .info-item {
          gap: 16px;

          .icon {
            width: 40px;
            height: 40px;
          }

          .details {
            h3 {
              font-size: 16px;
            }

            p, a {
              font-size: 14px;
            }
          }
        }
      }
  }

`

export default ContactSection;
